<template>
  <v-card class="pb-4 pr-5">
    <v-dialog v-model="location" v-if="location"
              max-width="600"
              @input="v => v || restoreLocationForm()">
      <v-card class="pa-4">
        <v-layout column>
          <span class="title">Edit Location</span>
          <v-flex class="mt-2">
            <v-flex sm6>
              <v-text-field v-model="location.label"
                            label="Label"></v-text-field>
            </v-flex>
          </v-flex>
          <v-flex class="mt-2">
            <v-flex sm6>
              <v-text-field v-model="location.daytimePhone"
                            label="Daytime Phone"></v-text-field>
            </v-flex>
          </v-flex>
          <v-flex class="mt-2">
            <v-flex sm6>
              <v-text-field v-model="location.nightTimePhone"
                            label="Evening / Night Phone"></v-text-field>
            </v-flex>
          </v-flex>
          <v-flex class="mt-2">
            <v-flex sm6>
              <AddressSearch label="Address"
                             v-model="location.locationPlaceId">
              </AddressSearch>
            </v-flex>
          </v-flex>
          <v-flex class="mt-2">
            <v-flex sm6>
              <v-textarea v-model="location.instructions"
                          label="Notes"></v-textarea>
            </v-flex>
          </v-flex>
          <v-card-actions>
            <v-spacer />
            <v-btn color="accent"
                   :disabled="!location.locationPlaceId || !location.label"
                   @click="saveLocation">Save</v-btn>
            <v-btn color="accent" flat @click="location = null">Cancel</v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout :column="$vuetify.breakpoint.smAndDown" align-baseline>
      <div class="title mt-4" :class="{'mr-3': !$vuetify.breakpoint.smAndDown}">
        {{ $t('company-profile.load-chute')}} Locations
      </div>
      <span :class="{'pl-2': !$vuetify.breakpoint.smAndDown}">
        Stockyards provide directions to their {{$tc('company-profile.load-chutes', 2)}} to assist drivers arrive.
      </span>
    </v-layout>
    <v-layout column sm6>
      <v-btn v-if="$vuetify.breakpoint.smAndDown && !showForm"
             @click="showForm = true"
             class="accent">
        Add Location
      </v-btn>
      <v-layout :column="$vuetify.breakpoint.smAndDown" v-if="isAdmin"
                v-show="!$vuetify.breakpoint.smAndDown || showForm">
        <v-flex sm6 xs12 class="mr-2">
          <v-layout :column="$vuetify.breakpoint.smAndDown">
            <v-flex sm4 xs12 class="mr-2">
              <v-text-field label="Label Name *" v-model="locationLabel"/>
            </v-flex>
            <v-flex sm4 xs12 class="mr-2">
              <v-text-field label="Daytime Phone" v-model="locationDayPhone"/>
            </v-flex>
            <v-flex sm4 xs12 class="mr-2">
              <v-text-field label="Evening / Night Phone" v-model="locationNightPhone"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm12 >
              <AddressSearch label="Address *"
                             showPlaceHolder
                             v-model="locationPlaceId"></AddressSearch>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex sm4 xs12 class="mr-2">
          <v-layout>
            <v-flex sm12 >
              <v-textarea label="Notes" class="mt-2 pt-1" v-model="locationNotes"/>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex sm2 class="mr-2">
          <v-btn :disabled="!locationPlaceId || !locationLabel"
                 @click="addLocation"
                 class="accent">
            Add Location
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <LoadMap v-model="locationPlaceId"
                   editPosition
                   singleValue>
          </LoadMap>
        </v-flex>
      </v-layout>
      <v-layout column v-if="hasLoadingChutes">
        <div class="title mr-3 mt-4 primary--text">
          {{$t('company-profile.load-chute')}} Locations
        </div>
        <template v-if="$vuetify.breakpoint.smAndDown">
          <v-card  v-for="(location, index) in loadingChutes" :key="index" class="xs12 my-2">

            <v-card-title>
              <v-layout column>
                <h6 class="title">
                  {{location.label}}
                </h6>
              </v-layout>
            </v-card-title>

            <v-card-text>
              <b>Daytime Phone:</b> {{location.daytimePhone}}<br/>
              <b>Evening / Night Phone:</b> {{location.nightTimePhone}}<br/>
              <b>Address:</b> {{location.googlePlaceName}}<br/>
              <b>Notes:</b> {{location.instructions}}<br/>
              <v-layout row wrap>
                <v-flex>
                  <v-btn @click="editLocation(location, index)" v-if="isAdmin"
                         flat small color="primary">Edit</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn flat small color="accent" v-if="isAdmin"
                         @click="removeLocation(index, _.get(location, 'label'))">
                    Remove
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </template>
        <v-layout v-else column class="mt-3">
          <v-layout>
            <v-flex sm2 class="secondary--text">Label Name</v-flex>
            <v-flex sm1 class="secondary--text">Daytime Phone</v-flex>
            <v-flex sm2 class="secondary--text">Evening / Night Phone</v-flex>
            <v-flex sm3 class="secondary--text">Address</v-flex>
            <v-flex sm3 class="secondary--text">Notes</v-flex>
            <v-flex sm1 v-if="isAdmin" class="secondary--text">Actions</v-flex>
          </v-layout>
          <v-divider class="my-1" />
          <template v-for="(location, index) in loadingChutes">
            <v-layout :key="index">
              <v-flex sm2>{{_.get(location, 'label')}}</v-flex>
              <v-flex sm1>{{_.get(location, 'daytimePhone')}}</v-flex>
              <v-flex sm2>{{_.get(location, 'nightTimePhone')}}</v-flex>
              <v-flex sm3>{{_.get(location, 'googlePlaceName')}}</v-flex>
              <v-flex sm3>{{_.get(location, 'instructions')}}</v-flex>
              <v-flex sm1 v-if="isAdmin">
                <v-btn @click="editLocation(location, index)"
                       flat small color="primary">Edit</v-btn>
              </v-flex>
              <v-flex sm1 v-if="isAdmin" class="accent--text">
                <v-btn flat small color="accent"
                       @click="removeLocation(index, _.get(location, 'label'))">
                  Remove
                </v-btn>
              </v-flex>
            </v-layout>
            <v-divider class="my-1" :key="'divider_'+index"/>
          </template>
        </v-layout>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<script>
import _ from 'lodash';
import API from '@/api';

import AddressSearch from '@/components/AddressSearch';
import LoadMap from '@/components/LoadMap';

import * as Companies from '@/types/models/company';
import * as types from '@/store/mutationTypes';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'LoadingChutesSection',
  props: {
    isAdmin: {
      type: Boolean,
    },
    company: {
      type: Object,
    },
  },
  data() {
    return {
      location: null,
      locationNotes: null,
      locationLabel: null,
      locationDayPhone: null,
      locationNightPhone: null,
      locationPlaceId: null,
      showForm: false,
    };
  },
  components: {
    LoadMap,
    AddressSearch,
  },
  computed: {
    _() {
      return _;
    },
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    hasLoadingChutes() {
      return Companies.hasLoadingChutes(this.company);
    },
    loadingChutes() {
      if (this.hasLoadingChutes) {
        return Companies.loadingChutes(this.company);
      }
      return [];
    },
  },
  methods: {
    async saveLocation() {
      const locations = this.loadingChutes.slice();
      const editedLocation = this.location;
      editedLocation.googlePlaceId = _.get(this.location, 'locationPlaceId.place_id', null);
      editedLocation.googlePlaceName = _.get(this.location, 'locationPlaceId.description', null);
      locations[this.location.index] = editedLocation;

      try {
        await API.company.editLoadingInfo({
          companyId: this.company.id,
          body: { locations } });

        this.$emit('refresh');

        this.location = null;
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Location updated',
          timeout: 7000,
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      }
    },
    async removeLocation(index, name) {
      const confirmation = await this.$confirm(`Do you really want to remove ${name}?`);
      if (!confirmation) {
        return;
      }

      this.$store.dispatch('companies/removeLocation', { locationIndex: index });
    },
    restoreLocationForm() {
      this.location = null;
    },
    editLocation(location, index) {
      const locationClone = _.cloneDeep(location);
      locationClone.locationPlaceId = {
        place_id: location.googlePlaceId,
        description: location.googlePlaceName,
      };

      this.location = locationClone;
      this.location.index = index;
    },
    async addLocation() {
      this.$store.commit(`applications/${types.START_LOADING}`);

      try {
        this.$store.dispatch('companies/addLocation', {
          googlePlaceId: this.locationPlaceId.place_id,
          googlePlaceName: this.locationPlaceId.description,
          label: this.locationLabel,
          instructions: this.locationNotes,
          daytimePhone: this.locationDayPhone,
          nightTimePhone: this.locationNightPhone,
        });

        this.locationPlaceId = null;
        this.locationLabel = null;
        this.locationNotes = null;
        this.locationDayPhone = null;
        this.locationNightPhone = null;
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Sections/LoadingChutesSection.vue